import CardSlot from "../UI/cardSlot/CardSlot";
import styles from "./MainPage.module.css"
import "./index_global.css"
import Search from "../UI/Search/Search";
import { useContext, useEffect, useState } from "react";
import SlotProviders from "../../../../http/slotProviders";
import SlotsProviders from "../../Service/SlotsProviders";
import SpinPage from '../../../../components/UI/Spin/Spin';
import { Context } from "../../../../index";
import { observer } from "mobx-react-lite";
import ErrorComponent from "../../../../components/UI/Error/ErrorComponent";
import Footer from "../../../../components/Footer/Footer";
import { fillTextPage } from "../../../../Utils/FillTextPage";
import { useLocation } from "react-router-dom";
import ToolsAround from "../../../../components/UI/ToolsAround/ToolsAround";
import { Spin } from "antd";
function MainPageSlots({ category_games }) {
    const [dataProvidersList, setDataProvidersList] = useState([])
    const [dataGamesList, setDataGamesList] = useState([])
    const [statusToolUp, setStatusToolUp] = useState(false)
    const [loadingResources, setLoadingResources] = useState(true)



    const { store } = useContext(Context)
    const [isLoading, setIsLoading] = useState(true);
    const [visiableBlockProviders, setVisiableBlockProviders] = useState(false)
    let [dataSlice, setDataSlice] = useState(20)
    const [gamesList, setGamesList] = useState([])
    const [old_list, setOld_list] = useState([])
    const [like_slots, setLike_slots] = useState({})
    const [stateButtonLike, setStateButtonLike] = useState(false);

    const [providerCur, setProviderCur] = useState("all_providers_name")
    const [providersList, setProvidersList] = useState([])

    const [data, setData] = useState({})



    function handleCliclProvider(name) {

        if (visiableBlockProviders) {


            if (stateButtonLike) {
                setStateButtonLike(false)
            }
            setLoadingResources(true)
            setDataSlice(20)
            localStorage.setItem("name_provider" + category_games, name);
            setProviderCur(name)
            if (name === "all_providers_name") {
                name = "all"
            }
            setGamesList(data.games[name])

            setLoadingResources(false)
            setVisiableBlockProviders(false)
        }


    }

    function filter_list_provders(name) {


        const new_list = dataProvidersList.filter(item =>
            item.toLowerCase().includes(name.toLowerCase()))
        setProvidersList(new_list)


    }

    async function filter_list_games(name) {

        try {
            setLoadingResources(true)

            if (name) {


                const response = await SlotsProviders.searchSlots(name, category_games);

                if (response.status === 200) {
                    const data = response.data;

                    if (response.data.status === 1) {
                        setGamesList(response.data.dataGames)

                    } else {
                        store.add_message("error1", ErrorComponent)

                    }

                } else {

                    store.add_message("error1", ErrorComponent)

                }
            } else {
                setDataSlice(20)

                setGamesList(data.games.all)
            }

        } catch (e) {

            console.error(e)
            store.add_message("error1", ErrorComponent)


        } finally {
            setLoadingResources(false)
        }


    }

    const handleScroll = () => {

        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const scrollBuffer = 600; // Увеличьте это значение, чтобы увеличить радиус появления

        if ((scrollTop + windowHeight + scrollBuffer) >= documentHeight) {
            setDataSlice(prev => prev + 16);
        }

        if (window.innerHeight < scrollTop) {
            if (!statusToolUp) {
                setStatusToolUp(true)

            }
        } else {
            setStatusToolUp(false)
        }

        // Если пользователь достиг конца страницы, обновляем состояние dataSlice для подгрузки дополнительных элементов

    };



    async function getAllInformation() {
        try {

            setLoadingResources(true)
            const response = await SlotsProviders.getAll(category_games);
            //console.log(response.data)
            if (response.status === 200) {
                const data = response.data

                if (response.data.status === 1) {


                    setData(data.dataProviders)
                    setProvidersList(data.dataProviders.providers)
                    setDataProvidersList(data.dataProviders.providers)
                    setDataGamesList(data.dataProviders.games["all"])
                    let nameProvider = providerCur;
                    //console.log(providerCur)
                    if (nameProvider === "all_providers_name") {
                        nameProvider = "all"
                    }
                    //console.log(nameProvider)
                    setGamesList(data.dataProviders.games[nameProvider])
                    setLike_slots(data.dataProviders.like_slots)


                    setLoadingResources(false);


                }
            } else {
                store.add_message("error1", ErrorComponent)
            }
        } catch (e) {
            console.log(e)
            store.add_message("error1", ErrorComponent)
        } finally {
            setIsLoading(false)
            store.setIsLoadingComponent(false)
        }
    }
    useEffect(() => {
        console.log("change", store.current_url)
        console.log("change", category_games)
        if (store.current_url === "/slots" || store.current_url === "/live_dealers") {
            getAllInformation();
        }




    }, [store.current_url])
    useEffect(() => {
        fillTextPage("slots", store)
        getAllInformation()


        window.addEventListener('load', () => {

            setLoadingResources(false)
        });
        window.addEventListener('scroll', handleScroll);
        return () => {


            window.removeEventListener('scroll', handleScroll)
        }

    }, []);
    useEffect(()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        })
    },[gamesList])
    if (isLoading) {
        return <SpinPage />
    }
    return (
        <>
            <div className={styles.parent} style={{ position: "sticky", top: "60px", left: 0, zIndex: 4 }}>
                <div className={styles.containerLikeButton} onClick={() => {
                    if (stateButtonLike) {
                        setGamesList(old_list)
                        setStateButtonLike(false)


                    } else {
                        setOld_list(gamesList)
                        setGamesList(Object.values(like_slots))
                        setStateButtonLike(true)


                    }

                }}>
                    <i className={(stateButtonLike ? "fa-solid" : "fa-regular") + ` fa-heart`}></i>
                </div>
                <div className={styles.containerSearches}>
                    <Search provider_cur={providerCur} filter_list_provders={filter_list_provders} type={"provider"}
                        setVisiableBlockProviders={setVisiableBlockProviders} />
                    <Search filter_list_games={filter_list_games} type={"game"}
                        setVisiableBlockProviders={setVisiableBlockProviders} />
                </div>

                <div
                    className={styles.blockProviders + " " + (visiableBlockProviders ? styles.active : styles.unactive)}>
                    <div onClick={() => handleCliclProvider("all_providers_name")}
                        className={`${styles.block} ${(("all_providers_name" === providerCur) || ("all" === providerCur)) ? styles.active : ""}`}
                        key={-1}> {/* Добавляем key для каждого элемента в списке */}
                        {store.dataLang["all_providers_name"]}
                    </div>
                    {providersList.map(el =>

                        <div onClick={() => handleCliclProvider(el)}
                            className={`${styles.block} ${el === providerCur ? styles.active : ""}`}
                            key={el.id}> {/* Добавляем key для каждого элемента в списке */}
                            {el}
                        </div>
                    )}
                </div>
            </div>
            <div className={`${styles.mainContainer} fadeAnimationMain`} id="main">
                


                {loadingResources ? <SpinPage /> : (


                    <div className={`${styles.containerSlots} fadeAnimationMain`}>
                        {gamesList.length > 0 ? (
                            gamesList.slice(0, dataSlice).map(el => (
                                <div className={styles.wrapperCard} key={el.id}>
                                    <CardSlot
                                        category_games={category_games}
                                        setLike_slots={setLike_slots}
                                        provider={el.provider}
                                        isLike={like_slots[el.uuid] ? true : false}
                                        isVpn={false}
                                        RTP={el.rtp}
                                        img={el.image}
                                        name={el.name}
                                        gameCode={el.uuid}
                                    />
                                </div>
                            ))
                        ) : (
                            !loadingResources && (
                                <div className={styles.NameNoSlots}>{store.dataLang["no_slot_name"]}</div>
                            )
                        )}
                    </div>


                )}


            </div>
            <div className={styles.bottomFooter}>
                <Footer />
            </div>


        </>
    );
}

export default observer(MainPageSlots)